<script setup>
import { useRequestsStore } from "@/stores/storeRequests";

const storeRequests = useRequestsStore();
</script>
<template>
	<div class="profile__confirmation">
		<span class="profile__confirmation-dot">!</span>
		<div class="profile__confirmation-header-text">
			<p>Пожалуйста, подтвердите свой адрес электронной почты, чтобы получить полный доступ к подаче заявки. Мы отправили письмо со ссылкой на почту <span class="">{{ storeRequests.userData?.email}}.</span></p>
			<p>Я не получил(а) письмо подтверждение. <button type="button" @click="storeRequests.repeatAccept()" >Подтвердить почту</button></p>
		</div>	
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.profile__confirmation {
    width: 75%;
	display: flex;
	align-items: start;
	gap: 1.4rem;
	font-weight: 400;
	font-size: 1.8rem;
	line-height: 140%;
    @media (max-width: vars.$xx) {
		width: 100%;
		line-height: 120%;
	}
	
}
.profile__confirmation-dot {
	font-size: 2.4rem;
	line-height: 140%;
	color: var(--red);
}
.profile__confirmation-header-text {
    display: grid;
    gap: 1rem;
	button, span {
		color: var(--red);
	}
}
</style>
